import { render, staticRenderFns } from "./VariantsOption.vue?vue&type=template&id=b600aa32"
import script from "./VariantsOption.vue?vue&type=script&lang=js"
export * from "./VariantsOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports